/**
 * Constantes centralizadas para integrações com plataformas de anúncios
 */

export interface PortalInfo {
  id: string
  nome: string
  descricao: string
  cor: string
  corHex: string
  logo: string
}

// URLs das logos das plataformas (armazenadas localmente em /assets/logos/)
export const portalLogos: Record<string, string> = {
  OLX: '/assets/logos/olx.ico',
  WEBMOTORS: '/assets/logos/webmotors.png',
  MERCADOLIVRE: '/assets/logos/mercadolivre.svg',
  ICARROS: '/assets/logos/icarros.ico',
  MOBIAUTO: '/assets/logos/mobiauto.png',
  USADOSBR: '/assets/logos/usadosbr.png',
  AUTOLINE: '/assets/logos/autoline.ico',
  NAPISTA: '/assets/logos/napista.png',
}

// Cores de fundo das plataformas (classes Tailwind)
export const portalColors: Record<string, string> = {
  OLX: 'bg-purple-500',
  WEBMOTORS: 'bg-orange-500',
  MERCADOLIVRE: 'bg-yellow-500',
  ICARROS: 'bg-blue-500',
  MOBIAUTO: 'bg-red-500',
  USADOSBR: 'bg-green-500',
  AUTOLINE: 'bg-cyan-500',
  NAPISTA: 'bg-indigo-500',
}

// Cores hexadecimais das plataformas (para gráficos, etc.)
export const portalColorsHex: Record<string, string> = {
  OLX: '#a855f7',
  WEBMOTORS: '#f97316',
  MERCADOLIVRE: '#eab308',
  ICARROS: '#3b82f6',
  MOBIAUTO: '#ef4444',
  USADOSBR: '#22c55e',
  AUTOLINE: '#06b6d4',
  NAPISTA: '#6366f1',
}

// Lista completa de plataformas disponíveis
export const allPortals: PortalInfo[] = [
  {
    id: 'OLX',
    nome: 'OLX',
    descricao: 'Maior marketplace de classificados do Brasil',
    cor: 'bg-purple-500',
    corHex: '#a855f7',
    logo: portalLogos.OLX
  },
  {
    id: 'WEBMOTORS',
    nome: 'WebMotors',
    descricao: 'Portal especializado em veículos',
    cor: 'bg-orange-500',
    corHex: '#f97316',
    logo: portalLogos.WEBMOTORS
  },
  {
    id: 'MERCADOLIVRE',
    nome: 'Mercado Livre',
    descricao: 'Maior e-commerce da América Latina',
    cor: 'bg-yellow-500',
    corHex: '#eab308',
    logo: portalLogos.MERCADOLIVRE
  },
  {
    id: 'ICARROS',
    nome: 'iCarros',
    descricao: 'Portal de veículos do Itaú',
    cor: 'bg-blue-500',
    corHex: '#3b82f6',
    logo: portalLogos.ICARROS
  },
  {
    id: 'MOBIAUTO',
    nome: 'Mobiauto',
    descricao: 'Marketplace automotivo',
    cor: 'bg-red-500',
    corHex: '#ef4444',
    logo: portalLogos.MOBIAUTO
  },
  {
    id: 'USADOSBR',
    nome: 'UsadosBR',
    descricao: 'Portal de veículos usados',
    cor: 'bg-green-500',
    corHex: '#22c55e',
    logo: portalLogos.USADOSBR
  },
  {
    id: 'AUTOLINE',
    nome: 'Autoline',
    descricao: 'Portal de veículos Bradesco',
    cor: 'bg-cyan-500',
    corHex: '#06b6d4',
    logo: portalLogos.AUTOLINE
  },
  {
    id: 'NAPISTA',
    nome: 'NaPista',
    descricao: 'Marketplace do banco BV',
    cor: 'bg-indigo-500',
    corHex: '#6366f1',
    logo: portalLogos.NAPISTA
  },
]

// Lista de IDs de portais
export const portaisIds = allPortals.map(p => p.id)

// Helper para obter informações de um portal
export function getPortalInfo(portalId: string): PortalInfo | undefined {
  return allPortals.find(p => p.id === portalId.toUpperCase())
}

// Helper para obter logo de um portal
export function getPortalLogo(portalId: string): string {
  return portalLogos[portalId.toUpperCase()] || ''
}

// Helper para obter cor de um portal
export function getPortalColor(portalId: string): string {
  return portalColors[portalId.toUpperCase()] || 'bg-gray-500'
}
